import { AnnounceMode } from '../components/ClinAnnounceBar/ClinAnnounceBar'

export enum AnnounceEventType {
  SHOW = 'ShowAnnounceEvent',
  HIDE = 'HideAnnounceEvent',
  UPDATE_FLAG = 'UpdateAnnounceEvent'
}

// Show ------------------------------------------------------------------------

export interface IShowAnnounceEvent {
  /** Event type is fixed */
  type: AnnounceEventType.SHOW
  /** Title announce bar mode */
  mode: AnnounceMode
  /** Description of the announce */
  description?: string
  /** Title of the announce */
  title?: string
  /** Should clear announcement on navigation */
  clearOnNavigationFlag?: boolean
}

export const createAnnounceEvent = (
  mode: AnnounceMode,
  description?: string,
  title?: string,
  clearOnNavigationFlag: boolean = true
): IShowAnnounceEvent => ({
  type: AnnounceEventType.SHOW,
  mode,
  description,
  title,
  clearOnNavigationFlag
})

// Hide ------------------------------------------------------------------------

export interface IHideAnnounceEvent {
  type: AnnounceEventType.HIDE
}

export const clearAnnounceEvent = (): IHideAnnounceEvent => ({
  type: AnnounceEventType.HIDE
})

// Update ------------------------------------------------------------------------

export interface IUpdateAnnounceFlag {
  type: AnnounceEventType.UPDATE_FLAG
  clearOnNavigationFlag: boolean
}

export const updateAnnounceClearFlag = (
  clearOnNavigationFlag: boolean
): IUpdateAnnounceFlag => ({
  type: AnnounceEventType.UPDATE_FLAG,
  clearOnNavigationFlag
})

export type IAnnounceEvent =
  | IShowAnnounceEvent
  | IHideAnnounceEvent
  | IUpdateAnnounceFlag
